import {HttpService} from "../../App/services/http";

const rates = () => {
  return HttpService.get("/currency/rates")
    .then(response => {
      const { rates } = response;
      return rates
    })
}

export const CurrencyServices = {
  rates
}